/** @format */

import * as React from "react";
import {
  Box,
  ButtonGroup,
  Image,
  Text,
  Link,
  Flex,
  Stack,
  useMediaQuery
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import { commonInfo as commonInfoEn } from "@common/en";
import { Language } from "@src/stores/Settings";
import { useStores } from "@src/hooks/useStores";
import colors from "@src/style/colors";
import theme from "@src/style/theme";
import { observer } from "mobx-react";

export const Footer: React.FC = observer(() => {
  const { settings } = useStores();
  const [isSmall, isMedium] = useMediaQuery([
    `(max-width: ${theme.breakpoints.md})`,
    `(min-width: ${theme.breakpoints.md})`
  ]);

  const fontSize = { base: "10px", md: "14px", lg: "18px" };
  const textGap = { base: "10px", sm: "24px", md: "24px", lg: "32px" };
  const sectionMargin = { base: "20px", sm: "40px" };
  const imgSize = {
    base: "28px",
    sm: "32px",
    md: "32px",
    lg: "38px"
  };

  return (
    <Flex
      width={"100%"}
      flexDirection={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      bgColor={colors.white}
      paddingX={{
        base: "20px",
        sm: "20px",
        md: "65px",
        lg: "108px"
      }}
      paddingY={{
        base: "50px",
        sm: "70px",
        md: "80px",
        lg: "100px"
      }}
    >
      {settings.language === Language.korean && (
        <Flex
          maxWidth={theme.breakpoints.mx}
          width={"100%"}
          flexDirection={{ base: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={{ base: "flex-start", md: "flex-end" }}
        >
          <Flex
            flexGrow={1}
            flexDirection={"column"}
            justifyContent={"flex-end"}
            alignItems={"start"}
            fontSize={fontSize}
            color={colors.coolGray200}
            gap={textGap}
          >
            <Text fontWeight={"700"}>{commonInfo.footer.title}</Text>
            {commonInfo.footer.policy.map((item, index) => (
              <Link href={item.url} isExternal key={index}>
                <Text fontWeight={index == 1 ? "700" : "400"}>{item.name}</Text>
              </Link>
            ))}
            <Stack direction={"row"}>
              <Text>Contact Business</Text>
              <Link href={`mailto:${commonInfo.footer.mail}`} isExternal>
                <Text>{commonInfo.footer.mail}</Text>
              </Link>
            </Stack>
          </Flex>
          {isSmall && (
            <Box
              width={"100%"}
              height={"1px"}
              bgColor={"rgba(0, 0, 0, 0.08)"}
              mt={sectionMargin}
            ></Box>
          )}
          <Flex
            flexGrow={1}
            flexDirection={"column"}
            justifyContent={"flex-end"}
            alignItems={{ base: "start", md: "end" }}
            fontSize={fontSize}
            color={colors.coolGray200}
            gap={textGap}
            mt={sectionMargin}
          >
            <ButtonGroup
              gap="2"
              justifyContent={{ base: "flex-start", md: "flex-end" }}
            >
              {commonInfo.footer.social.map((item, index) => (
                <Link href={item.url} isExternal key={index}>
                  <Image
                    boxSize={imgSize}
                    src={item.image}
                    style={{ transition: "opacity 0.3s" }}
                    _hover={{ opacity: "0.5" }}
                  />
                </Link>
              ))}
            </ButtonGroup>
            <Text>{commonInfo.footer.info}</Text>
            {/* <Text>{commonInfo.footer.address}</Text> */}
            <Text>{commonInfo.footer.copyright}</Text>
          </Flex>
        </Flex>
      )}
      {settings.language === Language.english && (
        <Flex
          maxWidth={theme.breakpoints.mx}
          width={"100%"}
          flexDirection={{ base: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={{ base: "flex-start", md: "flex-end" }}
        >
          <Flex
            flexGrow={1}
            flexDirection={"column"}
            justifyContent={"flex-end"}
            alignItems={"start"}
            fontSize={fontSize}
            color={colors.coolGray200}
            gap={textGap}
          >
            <Text fontWeight={"700"}>{commonInfoEn.footer.title}</Text>
            {commonInfoEn.footer.policy.map((item, index) => (
              <Link href={item.url} isExternal key={index}>
                <Text fontWeight={index == 1 ? "700" : "400"}>{item.name}</Text>
              </Link>
            ))}
            <Stack direction={"row"}>
              <Text>Contact Business</Text>
              <Link href={`mailto:${commonInfoEn.footer.mail}`} isExternal>
                <Text>{commonInfoEn.footer.mail}</Text>
              </Link>
            </Stack>
          </Flex>
          {isSmall && (
            <Box
              width={"100%"}
              height={"1px"}
              bgColor={"rgba(0, 0, 0, 0.08)"}
              mt={sectionMargin}
            ></Box>
          )}
          <Flex
            flexGrow={1}
            flexDirection={"column"}
            justifyContent={"flex-end"}
            alignItems={{ base: "start", md: "end" }}
            fontSize={fontSize}
            color={colors.coolGray200}
            gap={textGap}
            mt={sectionMargin}
          >
            <ButtonGroup
              gap="2"
              justifyContent={{ base: "flex-start", md: "flex-end" }}
            >
              {commonInfoEn.footer.social.map((item, index) => (
                <Link href={item.url} isExternal key={index}>
                  <Image
                    boxSize={imgSize}
                    src={item.image}
                    style={{ transition: "opacity 0.3s" }}
                    _hover={{ opacity: "0.5" }}
                  />
                </Link>
              ))}
            </ButtonGroup>
            <Text>{commonInfoEn.footer.info}</Text>
            {/* <Text>{commonInfoEn.footer.address}</Text> */}
            <Text>{commonInfoEn.footer.copyright}</Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
});

export default Footer;
